import { nextSceneNodeId } from "./normalizeFlowNodeIds";

interface SceneFlowNode {
  id: string;
  label: string;
  type: string;
  data?: string | null;
  lineupId?: string | null;
}

interface SceneFlowDiagram {
  nodes: SceneFlowNode[];
  edges: Array<{
    source: string;
    target: string;
    sourceHandle?: string | null;
  }>;
}

/** Add the scene's unconnected flow node without changing existing graph references. */
export function withSceneFlowNode<T extends SceneFlowDiagram>(
  diagram: T | null | undefined,
  sceneName: string
): T | SceneFlowDiagram {
  if (
    diagram?.nodes.some(
      (node) => node.type === "scene" && node.label === sceneName
    )
  ) {
    return diagram;
  }
  const nodes = diagram?.nodes || [];
  const usedIds = nodes.map((node) => node.id);
  const id =
    nextSceneNodeId(sceneName, usedIds) || nextSceneNodeId("scene", usedIds);
  return {
    ...(diagram || { edges: [] }),
    nodes: [
      ...nodes,
      { id, label: sceneName, type: "scene", data: null, lineupId: null },
    ],
  };
}
